/**
 * PRIVATE
 * Flatten a deep object into a one level object with it’s path as key
 *
 * @param  {object} object - The object to be flattened
 *
 * @return {object}        - The resulting flat object
 */
export default object => Object.assign({}, ...(function _flatten(objectBit, path = '') {
  return [].concat(
      ...Object.keys(objectBit).map((key) => {
        // if (typeof objectBit[key] === 'undefined' || objectBit[key] === null) {
        //   return ;
        // }
        if (typeof objectBit[key] === 'object' && objectBit[key] !== null) {
          return _flatten(objectBit[key], `${path}/${key}`);
        }

        return ({ [`${path}/${key}`]: objectBit[key] });
      }),
    );
}(object)));



// WEBPACK FOOTER //
// ./src/utils/general/Flatten.js